<p-dialog [header]="ui('Advanced Search', 'بحث متقدم')" [(visible)]="advancedSearchVisible" [modal]="true"
	[style]="{ width: 'min(96vw, 1320px)' }" [contentStyle]="{ overflow: 'visible' }" [draggable]="false">
	<form [formGroup]="filtersForm" class="advanced-search-form">
		<div class="advanced-search-grid">
			<div class="filter-field wide-field">
				<p-inputGroup>
					<p-inputGroupAddon><fa-icon [icon]="icons.search"></fa-icon></p-inputGroupAddon>
					<p-iftaLabel>
						<input pInputText id="searchText" formControlName="searchText" />
						<label for="searchText">{{ ui('Search reference, customer, route, equipment or commodity', 'ابحث بالمرجع أو العميل أو المسار أو المعدات أو البضاعة') }}</label>
					</p-iftaLabel>
				</p-inputGroup>
			</div>

			<div class="filter-field">
				<p-inputGroup>
					<p-inputGroupAddon><fa-icon [icon]="icons.list"></fa-icon></p-inputGroupAddon>
					<p-iftaLabel>
						<input pInputText id="referenceNumber" formControlName="referenceNumber" />
						<label for="referenceNumber">{{ ui('Reference Number', 'رقم المرجع') }}</label>
					</p-iftaLabel>
				</p-inputGroup>
			</div>

			<div class="filter-field">
				<p-inputGroup>
					<p-inputGroupAddon><fa-icon [icon]="icons.user"></fa-icon></p-inputGroupAddon>
					<p-iftaLabel>
						<p-select [options]="customerOptions" formControlName="customer" class="w-full" appendTo="body"
							[filter]="true"
							[showClear]="true" inputId="customer"></p-select>
						<label for="customer">{{ ui('Customer', 'العميل') }}</label>
					</p-iftaLabel>
				</p-inputGroup>
			</div>

			<div class="filter-field">
				<p-inputGroup>
					<p-inputGroupAddon><fa-icon [icon]="icons.user"></fa-icon></p-inputGroupAddon>
					<p-iftaLabel>
						<p-select [options]="clientOptions" formControlName="client" class="w-full" appendTo="body"
							[filter]="true"
							[showClear]="true" inputId="client"></p-select>
						<label for="client">{{ ui('Client', 'الشركة') }}</label>
					</p-iftaLabel>
				</p-inputGroup>
			</div>

			<div class="filter-field">
				<p-inputGroup>
					<p-inputGroupAddon><fa-icon [icon]="icons.marker"></fa-icon></p-inputGroupAddon>
					<p-iftaLabel>
						<p-select [options]="originOptions" formControlName="pickupLocation" class="w-full" appendTo="body"
							[filter]="true"
							[showClear]="true" inputId="advancedOrigin"
							(onFilter)="onLocationOptionFilter('origin', $event)"></p-select>
						<label for="advancedOrigin">{{ ui('Origin', 'مصدر الاستلام') }}</label>
					</p-iftaLabel>
				</p-inputGroup>
			</div>

			<div class="filter-field">
				<p-inputGroup>
					<p-inputGroupAddon><fa-icon [icon]="icons.mapLocation"></fa-icon></p-inputGroupAddon>
					<p-iftaLabel>
						<p-select [options]="destinationOptions" formControlName="deliveryLocation" class="w-full"
							appendTo="body" [filter]="true" [showClear]="true" inputId="advancedDestination"
							(onFilter)="onLocationOptionFilter('destination', $event)"></p-select>
						<label for="advancedDestination">{{ ui('Destination', 'وجهة التسليم') }}</label>
					</p-iftaLabel>
				</p-inputGroup>
			</div>

			<div class="filter-field">
				<p-inputGroup>
					<p-inputGroupAddon><fa-icon [icon]="icons.truck"></fa-icon></p-inputGroupAddon>
					<p-iftaLabel>
						<p-select [options]="equipmentOptions" formControlName="equipment" class="w-full" appendTo="body"
							[filter]="true"
							[showClear]="true" inputId="advancedEquipment"
							(onFilter)="onLocationOptionFilter('equipment', $event)"></p-select>
						<label for="advancedEquipment">{{ ui('Equipment Type', 'نوع المعدات') }}</label>
					</p-iftaLabel>
				</p-inputGroup>
			</div>

			<div class="filter-field">
				<p-inputGroup>
					<p-inputGroupAddon><fa-icon [icon]="icons.truck"></fa-icon></p-inputGroupAddon>
					<p-iftaLabel>
						<p-inputNumber inputId="equipmentCount" formControlName="equipmentCount" [min]="0"
							[showButtons]="false"></p-inputNumber>
						<label for="equipmentCount">{{ ui('Equipment Count', 'عدد المعدات') }}</label>
					</p-iftaLabel>
				</p-inputGroup>
			</div>

			<div class="filter-field">
				<p-inputGroup>
					<p-inputGroupAddon><fa-icon [icon]="icons.box"></fa-icon></p-inputGroupAddon>
					<p-iftaLabel>
						<p-select [options]="commodityOptions" formControlName="commodity" class="w-full" appendTo="body"
							[filter]="true"
							[showClear]="true" inputId="commodity"
							(onFilter)="onLocationOptionFilter('commodity', $event)"></p-select>
						<label for="commodity">{{ ui('Commodity', 'البضاعة') }}</label>
					</p-iftaLabel>
				</p-inputGroup>
			</div>

			<div class="filter-field">
				<p-inputGroup>
					<p-inputGroupAddon><fa-icon [icon]="icons.dollar"></fa-icon></p-inputGroupAddon>
					<p-iftaLabel>
						<p-select [options]="paymentTermsOptions" formControlName="paymentTerms" class="w-full"
							appendTo="body" [filter]="true" [showClear]="true" inputId="paymentTerms"
							(onFilter)="onLocationOptionFilter('paymentTerms', $event)"></p-select>
						<label for="paymentTerms">{{ ui('Payment Terms', 'شروط الدفع') }}</label>
					</p-iftaLabel>
				</p-inputGroup>
			</div>

			<div class="filter-field">
				<p-inputGroup>
					<p-inputGroupAddon><fa-icon [icon]="icons.dollar"></fa-icon></p-inputGroupAddon>
					<p-iftaLabel>
						<p-select [options]="currencyOptions" formControlName="currencyCode" class="w-full" appendTo="body"
							[filter]="true"
							[showClear]="true" inputId="currencyCode"></p-select>
						<label for="currencyCode">{{ ui('Currency', 'العملة') }}</label>
					</p-iftaLabel>
				</p-inputGroup>
			</div>

			<div class="filter-field">
				<p-inputGroup>
					<p-inputGroupAddon><fa-icon [icon]="icons.flag"></fa-icon></p-inputGroupAddon>
					<p-iftaLabel>
						<p-select [options]="statusOptions" formControlName="status" class="w-full" appendTo="body"
							[filter]="true"
							[showClear]="true" inputId="advancedStatus"></p-select>
						<label for="advancedStatus">{{ ui('Status', 'الحالة') }}</label>
					</p-iftaLabel>
				</p-inputGroup>
			</div>

			<div class="filter-field">
				<p-inputGroup>
					<p-inputGroupAddon><fa-icon [icon]="icons.calendar"></fa-icon></p-inputGroupAddon>
					<p-iftaLabel>
						<p-datepicker id="pickupDateFrom" formControlName="pickupDate" [showIcon]="false" class="w-full"
							appendTo="body"></p-datepicker>
						<label for="pickupDateFrom">{{ ui('Pickup Date From', 'تاريخ الاستلام من') }}</label>
					</p-iftaLabel>
				</p-inputGroup>
			</div>

			<div class="filter-field">
				<p-inputGroup>
					<p-inputGroupAddon><fa-icon [icon]="icons.calendar"></fa-icon></p-inputGroupAddon>
					<p-iftaLabel>
						<p-datepicker id="pickupDateTo" formControlName="pickupDateTo" [showIcon]="false" class="w-full"
							appendTo="body"></p-datepicker>
						<label for="pickupDateTo">{{ ui('Pickup Date To', 'تاريخ الاستلام إلى') }}</label>
					</p-iftaLabel>
				</p-inputGroup>
			</div>

			<div class="filter-field">
				<p-inputGroup>
					<p-inputGroupAddon><fa-icon [icon]="icons.calendar"></fa-icon></p-inputGroupAddon>
					<p-iftaLabel>
						<p-datepicker id="createdAtFrom" formControlName="createdAtFrom" [showIcon]="false" class="w-full"
							appendTo="body"></p-datepicker>
						<label for="createdAtFrom">{{ ui('Created At From', 'تاريخ الإنشاء من') }}</label>
					</p-iftaLabel>
				</p-inputGroup>
			</div>

			<div class="filter-field">
				<p-inputGroup>
					<p-inputGroupAddon><fa-icon [icon]="icons.calendar"></fa-icon></p-inputGroupAddon>
					<p-iftaLabel>
						<p-datepicker id="createdAtTo" formControlName="createdAtTo" [showIcon]="false" class="w-full"
							appendTo="body"></p-datepicker>
						<label for="createdAtTo">{{ ui('Created At To', 'تاريخ الإنشاء إلى') }}</label>
					</p-iftaLabel>
				</p-inputGroup>
			</div>

			<div class="filter-field">
				<p-inputGroup>
					<p-inputGroupAddon><fa-icon [icon]="icons.dollar"></fa-icon></p-inputGroupAddon>
					<p-iftaLabel>
						<input pInputText id="minTargetRate" type="number" formControlName="rate" />
						<label for="minTargetRate">{{ ui('Target Rate Min', 'أقل سعر مستهدف') }}</label>
					</p-iftaLabel>
				</p-inputGroup>
			</div>

			<div class="filter-field">
				<p-inputGroup>
					<p-inputGroupAddon><fa-icon [icon]="icons.dollar"></fa-icon></p-inputGroupAddon>
					<p-iftaLabel>
						<input pInputText id="maxTargetRate" type="number" formControlName="maxRate" />
						<label for="maxTargetRate">{{ ui('Target Rate Max', 'أعلى سعر مستهدف') }}</label>
					</p-iftaLabel>
				</p-inputGroup>
			</div>
		</div>

		<div class="advanced-actions">
			<button pButton type="button" [label]="ui('Refresh Options', 'تحديث الخيارات')"
				class="p-button-text p-button-secondary icon-button" [loading]="filterOptionsLoading"
				(click)="refreshFilterOptions()">
				<fa-icon [icon]="icons.refresh"></fa-icon>
			</button>
			<button pButton type="button" [label]="ui('Clear', 'مسح')" class="p-button-text p-button-secondary icon-button"
				(click)="clearFilters()">
				<fa-icon [icon]="icons.filterClear"></fa-icon>
			</button>
			<button pButton type="button" [label]="ui('Search', 'بحث')" class="p-button-success icon-button"
				(click)="applyAdvancedFilters()">
				<fa-icon [icon]="icons.search"></fa-icon>
			</button>
		</div>
	</form>
</p-dialog>

<div class="loads-shell fade-in">
	<section class="page-hero">
		<div class="hero-content">
			<span class="eyebrow">{{ ui('Load Marketplace', 'سوق الأحمال') }}</span>
			<h1 class="hero-title">{{ 'LOADS.FIND.TITLE' | translate }}</h1>
			<p class="hero-copy">{{ ui('Search through thousands of live marketplace loads.', 'ابحث بين آلاف الأحمال النشطة في السوق.') }}</p>
			@if (activeSearchSummary(); as summary) {
			<div class="hero-search-summary" [class.is-empty]="summary.length === 0">
				@if (summary.length) {
				@for (item of summary; track item.label + item.value) {
				<span class="summary-chip" [title]="item.label + ': ' + item.value">
					<strong>{{ item.label }}</strong>
					<span>{{ item.value }}</span>
				</span>
				}
				} @else {
				<span class="summary-empty">{{ ui('No filters applied', 'لا توجد فلاتر مطبقة') }}</span>
				}
			</div>
			}
		</div>

		<div class="hero-side">
			@if (loadRequests$ | async; as page) {
			<div class="hero-stats">
				<div class="stat-card">
					<fa-icon [icon]="icons.truck"></fa-icon>
					<span class="stat-value">{{ page.totalElements || 0 }}</span>
					<span class="stat-label">{{ ui('Open loads', 'أحمال مفتوحة') }}</span>
				</div>
				<div class="stat-card">
					<fa-icon [icon]="icons.list"></fa-icon>
					<span class="stat-value">{{ pageSize }}</span>
					<span class="stat-label">{{ ui('Per page', 'لكل صفحة') }}</span>
				</div>
			</div>
			}

			<button pButton type="button" [label]="ui('Create Load', 'إنشاء حمل')"
				class="p-button-success create-load-button icon-button" (click)="createLoad()">
				<fa-icon [icon]="icons.plus"></fa-icon>
			</button>

			<div class="view-toggle">
				<button pButton [label]="'LOADS.FIND.VIEW_LIST' | translate"
					[class]="(viewMode === 'list' ? 'p-button-sm p-button-success' : 'p-button-sm p-button-text p-button-secondary') + ' icon-button'"
					(click)="setViewMode('list')">
					<fa-icon [icon]="icons.list"></fa-icon>
				</button>
				<button pButton [label]="'LOADS.FIND.VIEW_MAP' | translate"
					[class]="(viewMode === 'map' ? 'p-button-sm p-button-success' : 'p-button-sm p-button-text p-button-secondary') + ' icon-button'"
					(click)="setViewMode('map')">
					<fa-icon [icon]="icons.map"></fa-icon>
				</button>
			</div>
		</div>
	</section>

	@if (loadRequests$ | async; as page) {
	<div class="grid board-grid">
		<div class="col-12 xl:col-9 panel-column">
			<section class="market-panel">
				<header class="panel-header">
					<div>
						<div class="panel-kicker">{{ ui('Load Board', 'لوحة الأحمال') }}</div>
						<h2>{{ viewMode === 'list' ? ('LOADS.FIND.LOADS_FOUND' | translate:{count: page.totalElements || 0}) : ('LOADS.FIND.VIEW_MAP' | translate) }}</h2>
						<p>{{ ui('Newest marketplace requests first, with route, equipment, and pricing context.', 'أحدث طلبات السوق أولاً مع تفاصيل المسار والمعدات والسعر.') }}</p>
					</div>
				</header>

				<div class="results-summary">
					<span>{{ ui('Page', 'صفحة') }} {{ pageNumber + 1 }}</span>
				</div>

				@if (viewMode === 'list') {
				<div class="scrollable-list">
					@for (load of page.content; track load.id) {
					<article class="match-card load-card" (click)="openLoad(load.id!)">
						<div class="card-topline">
							<div class="title-wrap">
								<p-tag [value]="statusLabel(load.status || 'POSTED')"
									[severity]="load.status === 'BOOKED' ? 'success' : 'info'"></p-tag>
								<div>
									<div class="reference-pill">{{ load.referenceNumber || ('Load #' + load.id) }}</div>
								</div>
							</div>

							<div class="price-wrap">
								<span>{{ 'LOADS.FIND.TARGET_RATE' | translate }}</span>
								<strong>{{ formatTargetRate(load.targetRate, load.currencyCode) }}</strong>
							</div>
						</div>

						<div class="signal-strip">
							@for (badge of signalBadges(load); track badge.label) {
							<span class="info-chip demand-chip" [class.accent-chip]="badge.strong">
								<fa-icon [icon]="badge.icon"></fa-icon>{{ badge.label }}
							</span>
							}
						</div>

						<div class="route-block">
							<div class="route-marker">
								<span class="dot origin-dot"></span>
								<span class="line"></span>
								<span class="dot destination-dot"></span>
							</div>
							<div class="route-copy">
								<div>
									<div class="route-title">{{ load.originLabel || load.origin }}</div>
									<div class="route-meta">{{ formatDisplayDate(load.pickupDate) }}</div>
								</div>
								<div>
									<div class="route-title">{{ load.destinationLabel || load.destination }}</div>
									<div class="route-meta">{{ formatDisplayDate(load.deliveryDate) }}</div>
								</div>
							</div>
						</div>

						<div class="chips-row">
							<span class="info-chip"><fa-icon [icon]="icons.truck"></fa-icon>{{ load.equipmentTypeLabel || load.equipmentType || ui('Any equipment', 'أي معدات') }}</span>
							@if (load.weightLbs) {
							<span class="info-chip"><fa-icon [icon]="icons.box"></fa-icon>{{ formatWeightLbs(load.weightLbs) }}</span>
							}
							@if (load.pallets) {
							<span class="info-chip"><fa-icon [icon]="icons.table"></fa-icon>{{ formatPallets(load.pallets) }}</span>
							}
							@if (load.temperatureControlled) {
							<span class="info-chip accent-chip">{{ ui('Temp controlled', 'تحكم بالحرارة') }}</span>
							}
							@if (load.commodity) {
							<span class="info-chip">{{ load.commodityLabel || load.commodity }}</span>
							}
						</div>

						@if (load.trustSummary; as trust) {
						<div class="trust-strip">
							<span class="info-chip trust-chip">
								<fa-icon [icon]="icons.shield"></fa-icon>
								{{ labelize(trust.company?.trustBadge) || labelize(trust.company?.verificationStatus) || labelize(trust.customer?.verificationStatus) || ui('Reviewed trust profile', 'ملف ثقة تمت مراجعته') }}
							</span>
							@if (trust.company?.paymentConfidence) {
							<span class="info-chip trust-chip neutral-chip">{{ ui('Payment', 'الدفع') }}: {{ labelize(trust.company?.paymentConfidence) }}</span>
							}
							@if (trust.company?.assuranceStatus) {
							<span class="info-chip trust-chip neutral-chip">{{ labelize(trust.company?.assuranceStatus) }}</span>
							}
							@if (trust.company?.trustScore !== null && trust.company?.trustScore !== undefined) {
							<span class="info-chip trust-chip score-chip">{{ ui('Score', 'درجة الثقة') }} {{ trust.company?.trustScore }}/100</span>
							}
							@if (!trust.company && trust.customer?.mobileVerified) {
							<span class="info-chip trust-chip neutral-chip">{{ ui('Mobile verified', 'الجوال موثق') }}</span>
							}
						</div>
						}

						<div class="card-actions" (click)="$event.stopPropagation()">
							<button pButton [label]="ui('View Details', 'عرض التفاصيل')"
								class="p-button-outlined p-button-secondary p-button-sm icon-button" (click)="openLoad(load.id!)">
								<fa-icon [icon]="icons.list"></fa-icon>
							</button>
						</div>
					</article>
					} @empty {
					<div class="state-block empty-state">
						<fa-icon [icon]="icons.inbox"></fa-icon>
						<span>{{ ui('No loads found matching your criteria.', 'لم يتم العثور على أحمال تطابق معاييرك.') }}</span>
					</div>
					}
				</div>

				<div class="pagination-panel">
					<p-paginator [rows]="pageSize" [totalRecords]="page.totalElements || 0"
						[first]="pageNumber * pageSize" [rowsPerPageOptions]="[10, 20, 50]"
						(onPageChange)="onPageChange($event)"></p-paginator>
				</div>
				} @else {
				<div class="map-board">
					<div class="map-surface">
						@if (selectedMapLoad(page); as selectedLoad) {
						<app-google-map class="w-full h-full block" [origin]="selectedLoad.origin"
							[destination]="selectedLoad.destination" [zoom]="6">
						</app-google-map>
						} @else {
						<div class="state-block empty-state">
							<fa-icon [icon]="icons.map"></fa-icon>
							<span>{{ ui('No mapped loads found.', 'لا توجد أحمال على الخريطة.') }}</span>
						</div>
						}
					</div>

					<aside class="map-route-panel">
						<div class="map-route-header">
							<span class="panel-kicker">{{ ui('Routes', 'المسارات') }}</span>
							<strong>{{ ui('Load Routes', 'مسارات الأحمال') }}</strong>
						</div>
						<div class="map-route-list">
							@for (load of page.content; track load.id) {
							<button type="button" class="route-option"
								[class.is-selected]="selectedMapLoad(page)?.id === load.id"
								(click)="selectMapLoad(load)">
								<span>{{ load.referenceNumber || ('Load #' + load.id) }}</span>
								<strong>{{ load.originLabel || load.origin }} &#8594; {{ load.destinationLabel || load.destination }}</strong>
								<small>{{ load.equipmentTypeLabel || load.equipmentType || ui('Any equipment', 'أي معدات') }} &bull; {{ formatDisplayDate(load.pickupDate, false) }}</small>
							</button>
							} @empty {
							<div class="state-block empty-state compact">
								<fa-icon [icon]="icons.inbox"></fa-icon>
								<span>{{ ui('No routes available.', 'لا توجد مسارات متاحة.') }}</span>
							</div>
							}
						</div>
					</aside>
				</div>
				}
			</section>
		</div>

		<div class="col-12 xl:col-3 panel-column">
			<aside class="side-stack">
				<section class="action-card filters-panel">
					<header class="filter-card-header">
						<div>
							<div class="panel-kicker">{{ ui('Refine', 'تنقيح') }}</div>
							<h3>{{ 'LOADS.FIND.FILTERS' | translate }}</h3>
							<p>{{ ui('Filter by lane, pickup date, equipment, status, and company scope.', 'صف حسب المسار وتاريخ الاستلام والمعدات والحالة ونطاق الشركة.') }}</p>
						</div>
						<button pButton [label]="'LOADS.FIND.CLEAR' | translate"
							class="p-button-text p-button-secondary p-button-sm icon-button" (click)="clearFilters()">
							<fa-icon [icon]="icons.filterClear"></fa-icon>
						</button>
					</header>

					<div class="company-toggle">
						<span>{{ ui('My Company', 'شركتي') }}</span>
						<p-toggleswitch [(ngModel)]="useShipperFilter" (onChange)="toggleShipperFilter($event)"></p-toggleswitch>
					</div>
					<button pButton type="button" [label]="ui('My Loads', 'أحمالي')"
						[class]="(useMyLoadsFilter ? 'p-button-success' : 'p-button-outlined p-button-secondary') + ' scope-filter-button icon-button'"
						(click)="toggleMyLoadsFilter()">
						<fa-icon [icon]="icons.user"></fa-icon>
					</button>
					<button pButton type="button" [label]="ui('Advanced Search', 'بحث متقدم')"
						class="p-button-outlined p-button-secondary scope-filter-button icon-button"
						(click)="openAdvancedSearch()">
						<fa-icon [icon]="icons.sliders"></fa-icon>
					</button>

					<form [formGroup]="filtersForm" class="filters-grid side-filters-grid">
						<div class="filter-field">
							<p-inputGroup>
								<p-inputGroupAddon><fa-icon [icon]="icons.marker"></fa-icon></p-inputGroupAddon>
								<p-iftaLabel>
									<p-select [options]="originOptions" formControlName="pickupLocation" class="w-full"
										appendTo="body" [filter]="true" [showClear]="true" inputId="pickupLocation"
										(onFilter)="onLocationOptionFilter('origin', $event)"></p-select>
									<label for="pickupLocation">{{ 'LOADS.FIND.PICKUP_ORIGIN' | translate }}</label>
								</p-iftaLabel>
							</p-inputGroup>
						</div>

						<div class="filter-field">
							<p-inputGroup>
								<p-inputGroupAddon><fa-icon [icon]="icons.mapLocation"></fa-icon></p-inputGroupAddon>
								<p-iftaLabel>
									<p-select [options]="destinationOptions" formControlName="deliveryLocation" class="w-full"
										appendTo="body" [filter]="true" [showClear]="true" inputId="deliveryLocation"
										(onFilter)="onLocationOptionFilter('destination', $event)"></p-select>
									<label for="deliveryLocation">{{ 'LOADS.FIND.DELIVERY_DEST' | translate }}</label>
								</p-iftaLabel>
							</p-inputGroup>
						</div>

						<div class="filter-field">
							<p-inputGroup>
								<p-inputGroupAddon><fa-icon [icon]="icons.calendar"></fa-icon></p-inputGroupAddon>
								<p-iftaLabel>
									<p-datepicker id="pickupDate" formControlName="pickupDate" [showIcon]="false" class="w-full"
										appendTo="body"></p-datepicker>
									<label for="pickupDate">{{ 'LOADS.FIND.PICKUP_DATE' | translate }}</label>
								</p-iftaLabel>
							</p-inputGroup>
						</div>

						<div class="filter-field">
							<p-inputGroup>
								<p-inputGroupAddon><fa-icon [icon]="icons.truck"></fa-icon></p-inputGroupAddon>
								<p-iftaLabel>
									<p-select [options]="equipmentOptions" formControlName="equipment" class="w-full" appendTo="body"
										[filter]="true"
										[showClear]="true" inputId="equipment"
										(onFilter)="onLocationOptionFilter('equipment', $event)"></p-select>
									<label for="equipment">{{ 'LOADS.FIND.EQUIPMENT_TYPE' | translate }}</label>
								</p-iftaLabel>
							</p-inputGroup>
						</div>

						<div class="filter-field">
							<p-inputGroup>
								<p-inputGroupAddon><fa-icon [icon]="icons.dollar"></fa-icon></p-inputGroupAddon>
								<p-iftaLabel>
									<p-select [options]="paymentTermsOptions" formControlName="paymentTerms" class="w-full"
										appendTo="body" [filter]="true" [showClear]="true" inputId="sidePaymentTerms"
										(onFilter)="onLocationOptionFilter('paymentTerms', $event)"></p-select>
									<label for="sidePaymentTerms">{{ ui('Payment Terms', 'شروط الدفع') }}</label>
								</p-iftaLabel>
							</p-inputGroup>
						</div>

						<div class="filter-field">
							<p-inputGroup>
								<p-inputGroupAddon><fa-icon [icon]="icons.flag"></fa-icon></p-inputGroupAddon>
								<p-iftaLabel>
									<p-select [options]="statusOptions" formControlName="status" class="w-full" appendTo="body"
										[filter]="true"
										[showClear]="true" inputId="status"></p-select>
									<label for="status">{{ ui('Status', 'الحالة') }}</label>
								</p-iftaLabel>
							</p-inputGroup>
						</div>

						<div class="filter-field">
							<p-inputGroup>
								<p-inputGroupAddon><fa-icon [icon]="icons.dollar"></fa-icon></p-inputGroupAddon>
								<p-iftaLabel>
									<input pInputText id="rate" type="number" formControlName="rate" />
									<label for="rate">{{ 'LOADS.FIND.TARGET_RATE' | translate }}</label>
								</p-iftaLabel>
							</p-inputGroup>
						</div>

						<div class="filter-actions">
							<button pButton type="button" [label]="'LOADS.FIND.APPLY_FILTERS' | translate"
								class="w-full p-button-success action-button icon-button" (click)="applyFilters()">
								<fa-icon [icon]="icons.search"></fa-icon>
							</button>
						</div>
					</form>
				</section>

				<section class="action-card">
					<div class="action-heading">
						<span class="panel-kicker">{{ ui('Hot Lanes', 'المسارات النشطة') }}</span>
						<h3>{{ ui('Marketplace activity', 'نشاط السوق') }}</h3>
					</div>
					<div class="insight-list">
						@for (lane of (hotLanes$ | async); track lane.origin + lane.destination) {
						<div class="insight-row">
							<div>
								<strong>{{ formatHotLaneRoute(lane) }}</strong>
								<span>{{ formatHotLaneActivity(lane.loadCount) }}</span>
							</div>
							<fa-icon [icon]="icons.route"></fa-icon>
						</div>
						} @empty {
						<div class="state-block compact"><span>{{ ui('No lane data.', 'لا توجد بيانات للمسارات.') }}</span></div>
						}
					</div>
				</section>

				<section class="action-card">
					<div class="action-heading">
						<span class="panel-kicker">{{ ui('Trends', 'الاتجاهات') }}</span>
						<h3>{{ ui('Hot Trends', 'الاتجاهات النشطة') }}</h3>
					</div>
					@if (trends$ | async; as trends) {
					<div class="trend-stack">
						<div>
							<span class="section-label">{{ ui('Top Equipment', 'أكثر المعدات طلباً') }}</span>
							<div class="chips-row">
								@for (item of trends.topEquipmentTypes; track item.label) {
								<span class="info-chip" [pTooltip]="formatTrendTooltip(item.count)">{{ formatTrendLabel(item.label) }}</span>
								}
							</div>
						</div>

						<div class="metric-card">
							<span>{{ ui('Avg Weight', 'متوسط الوزن') }}</span>
							<strong>{{ formatAverageWeight(trends.averageWeight) }}</strong>
						</div>
						<div class="metric-card">
							<span>{{ ui('Avg Pallets', 'متوسط المنصات') }}</span>
							<strong>{{ formatAveragePallets(trends.averagePallets) }}</strong>
						</div>
					</div>
					}
				</section>
			</aside>
		</div>
	</div>
	}
</div>
